import { routeAccessTree } from "./routesAccessTree";

type AccessMeta = {
  public?: boolean;
  //   layout?: string;
  //   redirectToIfLoggedIn?: string;
  //   roles?: string[];
};

type AccessNode = AccessMeta & {
  [key: string]: any;
};

export type MatchAccessResult = {
  public: boolean;
  meta?: AccessMeta;
  matchedPath: string[];
};

export const matchAccess = (pathname: string): MatchAccessResult => {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) {
    return { public: true, matchedPath: [] };
  }

  let node: AccessNode = routeAccessTree;
  const matchedPath: string[] = [];

  let meta: AccessMeta | undefined = undefined;

  for (const segment of segments) {
    const keys: string[] = Object.keys(node as object);
    const exactMatch = keys.find((key) => key === segment);
    const dynamicMatch = keys.find((key) => key.startsWith(":"));
    const wildcardMatch = keys.find((key) => key === "*");

    const nextKey: string | undefined = exactMatch ?? dynamicMatch ?? wildcardMatch;
    if (!nextKey) break;

    node = node[nextKey];
    matchedPath.push(nextKey);

    meta = node; // 가장 마지막 매칭된 노드의 정보를 meta에 저장
  }

  return {
    public: meta?.public ?? false,
    matchedPath,
    meta,
  };
};
